import {
  afterSetState,
  dollarsToCents,
  floatsOnly,
  handleInputChange,
} from "legacy/helpers.es6"
import AdjustmentSection from "legacy/manage/AdjustmentSection"
import PropTypes from "prop-types"
import React from "react"

class RefundForCancel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      adjustmentAmount: null,
      adjustmentDescription: null,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleAdjustmentChange = this.handleAdjustmentChange.bind(this)
    this.resetAdjustment = this.resetAdjustment.bind(this)
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleAdjustmentChange(event) {
    this.setState({ adjustmentAmount: floatsOnly(event.target.value) })
    afterSetState(this.updateRefundAmount.bind(this))
  }

  resetAdjustment() {
    this.setState({
      adjustmentAmount: null,
      adjustmentDescription: null,
    })
    afterSetState(this.updateRefundAmount.bind(this))
  }

  updateRefundAmount() {
    this.props.adjustmentDidUpdate(dollarsToCents(this.state.adjustmentAmount))
  }

  render() {
    return (
      <div>
        <AdjustmentSection
          handleAdjustmentChange={this.handleAdjustmentChange}
          handleInputChange={this.handleInputChange}
          resetAdjustment={this.resetAdjustment}
          adjustmentAmount={this.state.adjustmentAmount}
          adjustmentDescription={this.state.adjustmentDescription}
          currentPrice={this.props.currentPrice}
          newPrice={0}
          isCalculating={this.state.calculating}
          validator={this.props.validator}
          resourceName={this.props.resourceName}
        />
      </div>
    )
  }
}

RefundForCancel.propTypes = {
  adjustmentDidUpdate: PropTypes.func.isRequired,
  boaterCancel: PropTypes.bool,
  currentPrice: PropTypes.number,
  resourceName: PropTypes.string.isRequired,
  validator: PropTypes.object.isRequired,
}

export default RefundForCancel
